export default __webpack_public_path__ + "locales/de/ChangeUserStatusDialog.json?hash=8c670696f86b64c0f3acbba59151f913";